module.exports = __webpack_public_path__ + "c30f645ecfcafaaea670dc3a7cdae255.MP3";